import React from "react";

export default function About() {
  return (
    <div className="about">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 align-self-center">
            <h1>About</h1>
            <p>
              The goal of this token is to allow investors to enter our
              hedgefund based on purchased tokens.
            </p>
            <p>
              So the higher your allocation, the higher your ownership is on the
              Takashinu treasury, both profit and DAO based. This is a solution
              to average crypto investors who still whant to diversefy their
              portofolio and funnel funds into the art/NFT branch aswel as
              whales who are to lazy to select the right kind of great work and
              have the network to be able to be near a original murakami !
            </p>
          </div>
          <div className="col-lg-6 align-self-center text-center">
            <div className="desk-img">
              <img src="./Asserts/about-img.png" className="img-fluid" alt="" />
            </div>

            <div className="mob-img">
              <img
                src="./Asserts/about-mob-img.png"
                className="img-fluid"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
